import React from 'react';
import PropTypes from 'prop-types';

import './InvoiceInfo.scss';
import { Text } from '@nextiva/next-ui';

import { formatter } from 'utils';

export const blockName = 'invoice-info';

const InvoiceInfo = props => {
  const {
    invoice: { amount, formattedDate },
  } = props;

  return (
    <div
      data-testid={blockName}
      className={`${blockName}__row-with-value ${blockName}--small-margin-bottom`}
    >
      <Text kind="h4">
        <span className={`${blockName}--font-weight-medium ${blockName}-date`}>
          {formattedDate}
        </span>
      </Text>
      <Text kind="h4">
        <span
          className={`${blockName}--grey-text ${blockName}--font-weight-medium ${blockName}-amount`}
        >
          {formatter.format(amount)}
        </span>
      </Text>
    </div>
  );
};

InvoiceInfo.propTypes = {
  invoice: PropTypes.object.isRequired,
};

export default InvoiceInfo;
